import AbstractDispatcher from './AbstractDispatcher';
import Environment, { ENV_VARS } from '../../Environment';
import { ConnectableElement } from '@olive/olive-types';

export const SERVER_DISPATCHER_ID = 'server-dispatcher';

const SLEEP_BETWEEN_POLLS = 1000;

const dataLayerInvoke = '/data-layer/invoke';
const dataLayerPoll = '/data-layer/poll';

export default class ServerDispatcher extends AbstractDispatcher {



  async dispatch(props: { id: string; input?: unknown }): Promise<unknown> {
    let body;
    // TODO refactor, remove special handling for "formData" field
    if (props?.input && typeof (props.input) === 'object' && 'formData' in props.input && props?.input?.formData instanceof FormData) {
      body = handleFormaData(props);
    }
    else {
      body = JSON.stringify({
        id: props.id,
        input: props.input
      });
    }

    const invokeResp = await fetch(
      dataLayerInvoke,
      {
        method: 'POST',
        body: body,
        headers: body instanceof FormData ? undefined : { 'Content-Type': 'application/json' },
      }
    );
    if (!invokeResp.ok) {
      console.error('Error in server dispatcher during invoking data-layer');
      return null;
    }
    const invokeRespJSON = await invokeResp.json();
    if (invokeRespJSON.state !== 'INVOKED' && invokeRespJSON.state !== 'SUCCESS') {
      console.error('Error in server dispatcher during invoking data-layer', invokeRespJSON);
      return null;
    }

    const pollID = invokeRespJSON.jobID;
    console.info('pollID: ', pollID);

    await sleep(SLEEP_BETWEEN_POLLS);

    const result = null;
    while (result === null) {
      const pollResp = await fetch(
        dataLayerPoll,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            jobID: pollID,
          }),
        }
      );
      const pollRespJSON = await pollResp.json();
      console.info('poll response: ', pollRespJSON);
      if (pollRespJSON.state === 'SUCCESS') {
        console.info('dispatcher returning: ', pollRespJSON.result);
        return pollRespJSON.result;
      } else if (pollRespJSON.state === 'FAILURE') {
        console.error('Data layer returned error!');
        return null;
      }

      // not finished yet, sleep and try again
      await sleep(SLEEP_BETWEEN_POLLS);
    }

    return null;
  }

  canDispatch(): boolean {
    // everything we can't handle with other dispatchers we send to the server data-layer to handle there
    return true;
  }
}
function handleFormaData(props: { id: string; input?: unknown; }) {
  const formData = new FormData();
  const params = {};
  //@ts-expect-error
  for (const [key, value] of props.input.formData.entries()) {
    if (value instanceof File) {
      formData.append('file', value, value.name);
    } else {
      params[key] = value;
    }
  }

  formData.append('id', props.id);
  formData.append('input', JSON.stringify(params));
  formData.append('context', Environment.get(ENV_VARS.CONFIG_ID));

  return formData;
}

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
